import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getSpiderChart, getDatasourceAndDates } from '../../../api'
import { isFullscreen } from '../utils/Utils';
import { xlsxCustomExport } from '../utils/chartConfig';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

class SpiderChart extends Component{
	constructor(props) {
		super(props);

		const stateThis = this;
		this.state = {
			selectedDataset: undefined,
			chartConfig: {
				colors: this.props.colors,
				credits: {
					enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: this.props.chartType[0].type == 'ewcs' ? -270 : -130
					}
				},
				exporting: {
					enabled: this.props.exportingEnabled,
					sourceWidth: 1200,
					sourceHeight: 600,
					menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Indicator', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				chart: {
					backgroundColor: props.backgroundColor? props.backgroundColor : '#F0F0F0',
					polar: true,
					type: 'line',
					// height:this.props.fullCountryReport ? 320 : 770,
					spacingTop: props.fullCountryReport == true ? 45 : 10,
					events: {
                        render: function() {
                            let chart = this;
                            stateThis.showEurofoundImage(chart);
						}			
                    }
				},
				title: {
					text: props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.literals[`L${this.props.chartType[0].title}`]+"</h2>",
					align: 'left',
                    widthAdjust: -50,
                    y:20,
                    style: {
                        zIndex: 1,
                        lineHeight:36
                    }
					//x: -180
				},			
				pane: {
					size: '99%'
				},
				plotOptions: {
					series: {
						colors: this.props.colors,
						lineWidth:4,
						marker: {
							radius: 4,
							symbol: "circle"
						},
					},
					line: {
						dataLabels: {
							style: {
								textOutline: 0,
								textShadow: false,
								fontFamily: 'OpenSans-Bold',
								fontSize:this.props.fullCountryReport ? '14px' : '16px',
							},
							allowOverlap: false,
							padding:this.props.fullCountryReport ? 20 : 10,
							enabled: this.props.showDataLabel === true ? true : false,
							formatter: function () {
								if (this.series.name == 'EU27' || this.series.name == 'EU28')
								{
									return '<span style="color: ' + this.point.color + '">' + this.y + '%</span>';
								}
								else
								{
									return null;
								}
							}
						}
					}
				},
				legend: {
					margin: this.props.fullCountryReport ? 25 : 50
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y:-5
					}
				},
				xAxis: {
					tickmarkPlacement: 'on',
					lineWidth: 0,
					gridLineColor: '#acacac',
					gridLineWidth: 1,
					id: props.datasetSource,
					labels: {	
						distance: this.props.fullCountryReport ? 10 : 20,					
						style: {
							fontFamily: 'OpenSans',
							fontSize:this.props.fullCountryReport ? '12px' : '14px',
							color: 'black'
						}
					}
				},
				yAxis: {
					labels:{
						enabled: false
					},
					tickInterval: 20,
					gridLineInterpolation: 'polygon',
					gridLineColor: '#acacac',
					gridLineWidth: 1,
					lineWidth: 0,
					min: 0
				},
				tooltip: {
					useHTML: true,
					opacity: 1,
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor:"#529FA2",
					fontSize:'12px',
					zIndex: 100,
					style: {
						zIndex: 100
					},
					//formatter: SpiderChart.chartTooltip,		 
					formatter: function (e) {
						let dataset = e.chart.userOptions.xAxis.id;
						let text = "";
						if (this.x == props.literals.L22153){
							// Physical Risk - Vibrations, loud noise and temperature - Vibrations from tools or machinery
							text = props.literals.L324;
						}else if (this.x == props.literals.L22155){
							// Physical Risk - Vibrations, loud noise and temperature - Loud noise
							text = props.literals.L325;
						}else if (this.x == props.literals.L22156){
							// Physical Risk - Vibrations, loud noise and temperature - High temperatures
							text = props.literals.L326;
						}else if (this.x == props.literals.L22154){
							// Physical Risk - Vibrations, loud noise and temperature - Low temperatures
							text = props.literals.L327;
						}else if (this.x == props.literals.L22161){
							// Physical Risk - Ergonomic Risks ESENER - Positions
							if (dataset == "esener")
							{
								text = props.literals.L20676;
							}
							// Physical Risk - Ergonomic Risks EWCS - Positions
							else if (dataset == "ewcs")
							{
								text = props.literals.L347;
							}
						}else if (this.x == props.literals.L22165){
							// Physical Risk - Ergonomic Risks ESENER - Loads
							if (dataset == "esener")
							{
								text = props.literals.L20690;
							}
							// Physical Risk - Ergonomic Risks EWCS - Loads
							else if (dataset == "ewcs")
							{
								text = props.literals.L349;
							}
						}else if (this.x == props.literals.L22163){
							// Physical Risk - Ergonomic Risks ESENER - Sitting
							if (dataset == "esener")
							{
								text = props.literals.L793;
							}
							// Physical Risk - Ergonomic Risks EWCS - Sitting
							else if (dataset == "ewcs")
							{
								text = props.literals.L348;
							}
						}else if (this.x == props.literals.L22164){
							// Physical Risk - Ergonomic Risks ESENER - Movements
							if (dataset == "esener")
							{
								text = props.literals.L20677;
							}
							// Physical Risk - Ergonomic Risks EWCS - Movements
							else if (dataset == "ewcs")
							{
								text = props.literals.L350;
							}
						}else if (this.x == props.literals.L22162){
							// Physical Risk - Ergonomic Risks EWCS - Lifting and moving
							text = props.literals.L351;
						}else if (this.x == props.literals.L22171){
							// Worker involvement ESENER - Employees role and psychosocial risks
							text = props.literals.L22150;
						}else if (this.x == props.literals.L22172){
							// Worker involvement ESENER - H&S delegate or committee
							text = props.literals.L20685;
						}else if (this.x == props.literals.L22173){
							// Worker involvement ESENER - Employee representation
							text = props.literals.L20684;
						}else if (this.x == props.literals.L22174){
							// Worker involvement ESENER - Regular H&S discussions
							text = props.literals.L20687;
						}else if (this.x == props.literals.L22175){
							// Worker involvement ESENER - Controversial H&S discussions
							text = props.literals.L20688;
						}else if (this.x == props.literals.L22176){
							// Worker involvement EWCS - Employee meetings
							text = props.literals.L332;
						}else if (this.x == props.literals.L22177){
							// Worker involvement EWCS - Representation of employees
							text = props.literals.L352;
						}else if (this.x == props.literals.L22178){
							// Worker involvement EWCS - H&S delegate or committee
							text = props.literals.L353;
						}

						return ['<ul class="tooltip-item"><li><strong>' + text + '</strong><br></li>'].concat(
							this.points ? this.points.map(function (point) {
								return '<li><strong>' + point.series.name + ':</strong> ' + point.y + '% '+'</li>';
								}) : ['</ul>']	);
					},
					//split: true,
					shared:true
				},
				series: [],
			},
			typeCharts:[],
			selectedTypeChart: (this.props.selectedIndicator != undefined) ? this.props.selectedIndicator : this.props.datasetSource,
			selectedChart: this.props.datasetSource === 'ewcs' ? this.props.chartType[1] : this.props.chartType[0]
		}
	}

	showEurofoundImage = (chart) => {
        let isEurofoundIndicator = this.props.datasetSource == 'ewcs' ? true : false;
        if (!chart.customImage)
        {
            chart.customImage = chart.renderer.image(
                `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                chart.chartWidth - 130,
                chart.chartHeight - 37,
                130,
                37
            ).add();
            chart.customImage.attr({
				class:'osha-logo'
			});
        }
        else
        {
            chart.customImage.attr({
                x: chart.chartWidth - 130,
                y: chart.chartHeight - 37
            });
        }
        
        if(isEurofoundIndicator){
            if (!chart.customImageEurofound)
            {
                chart.customImageEurofound = chart.renderer.image(
                    `${IMG_URL}osh-barometer/img/eurofound-logo.png`,
                    chart.chartWidth - 270,
                    chart.chartHeight - 37,
                    130,
                    37
                ).add();
                chart.customImageEurofound.attr({
					class:'eurofound-logo'
				});
            }
            else
            {
                chart.customImageEurofound.attr({
                    x: chart.chartWidth - 270,
                    y: chart.chartHeight - 37
                });
            }
        }

        if (chart.fullscreen.isOpen) {
            chart.customImage.css({
                display: 'block'
            });
            if(isEurofoundIndicator){
                chart.customImageEurofound.css({
                    display: 'block'
                });
            }
            chart.container.className = 'highcharts-container full-screen';
        }
        else
        {
            chart.customImage.css({
                display: ''
            });
            if(isEurofoundIndicator){
                chart.customImageEurofound.css({
                    display: ''
                });
            }
            chart.container.className = 'highcharts-container';
        }
    }

	getLoadData = (chartType) =>{
		let categories = [];
        let auxSeries = [];
        let series = [];
		let chart
		const country1= this.props.selectCountry1;
		const country2= this.props.selectCountry2;
		const country3= this.props.selectCountry3;

		if (chartType.length > 1) 
		{
			chart = chartType.find((chart) => chart.type == this.props.datasetSource);
			if (this.props.datasetSource == null && this.props.datasetSource != null)
			{
				chart = chartType.find((chart) => chart.type == this.props.datasetSource);
				this.setState({ selectedTypeChart: this.props.datasetSource, selectedChart: chart });				
			}
			else if (chart.chart != this.state.selectedTypeChart.chart)
			{
				this.setState( { selectedChart: chart } );
			}
		} 
		else if (chartType.length == 1 && chartType[0].type == "ewcs")
		{
			chart = chartType[0];
			this.setState({ selectedTypeChart: chartType[0].type, selectedChart: chartType[0] });
		}
		else 
		{
			chart = chartType[0];
			this.setState({ selectedTypeChart: null, selectedChart: chart });
		}

		if(this.props.callbackLegend){
			this.props.callbackLegend(chart.legend);
		}
		// Load the texts for the credits in the image when maximising or exporting the chart
        this.getCredits(chart.chart, this.props.datasetID);

		if (chart.chart == '20080'){
			categories =[this.props.literals.L22161,this.props.literals.L22159,this.props.literals.L22164,this.props.literals.L22162]
		}else if (chart.chart == '20049'){
			categories =[this.props.literals.L22153,this.props.literals.L22155,this.props.literals.L22156,this.props.literals.L22154]
		}else if (chart.chart == '20101' && this.props.datasetID == 15) {
			categories =[this.props.literals.L22157,this.props.literals.L22159,this.props.literals.L22163]
		}else if (chart.chart == '20101') {
			categories =[this.props.literals.L22157,this.props.literals.L22159,this.props.literals.L22158,this.props.literals.L22163]
		} else if (chart.chart == '20106'){
			categories =[this.props.literals.L22171,this.props.literals.L22172,this.props.literals.L22173,this.props.literals.L22174,this.props.literals.L22175]
		}else if (chart.chart == '20069'){
			categories=[this.props.literals.L22176,this.props.literals.L22177,this.props.literals.L22178]
		}

		getSpiderChart(chart.chart, country1, country2, country3, this.props.datasetID)
		.then((res)=>{

			res.resultset.forEach(element => {
				let split = element.countryCode == 'EU27_2020' || element.countryCode == 'EU28' ? element.countryName : `(${element.countryCode}) ${element.countryName}`;
				if (!(split in auxSeries)) {
					auxSeries[split] = []
				}
				if(chart.chart == '20080'){
					auxSeries[split].push(
						element.data[this.props.literals.L347],
						element.data[this.props.literals.L349],
						element.data[this.props.literals.L350],
						element.data[this.props.literals.L351]
						)
				}else if(chart.chart == '20049'){
					auxSeries[split].push(
						element.data[this.props.literals.L324],
						element.data[this.props.literals.L325],
						element.data[this.props.literals.L326],
						element.data[this.props.literals.L327],
						)
				}else if(chart.chart == '20101'){
					if (this.props.datasetID == 15)
					{
						auxSeries[split].push(
							element.data['indicator1'],
							element.data['indicator2'],
							element.data['indicator3'],
						)
					}else 
					{
						auxSeries[split].push(
							element.data['indicator1'],
							element.data['indicator2'],
							element.data['indicator4'],
							element.data['indicator3'],
						)
					}
					
				}else if(chart.chart == '20106'){
					auxSeries[split].push(
						element.data['indicator3'],
						element.data['indicator2'],
						element.data['indicator1'],
						element.data['indicator4'],
						element.data['indicator5']
					)					
				}else if(chart.chart == '20069'){
					auxSeries[split].push(
						element.data[this.props.literals.L332],
						element.data[this.props.literals.L353],
						element.data[this.props.literals.L352]
					)
				}
			});

			for (let serie in auxSeries) {
				if (serie == 'EU27' || serie == 'EU28')
				{
					series.push({ name: serie, pointPlacement: 'on', data: auxSeries[serie], color: '#003399' });
				}
				else if (serie.indexOf(`(${this.props.selectCountry1})`) > -1)
				{
					series.push({ name: serie, pointPlacement: 'on', data: auxSeries[serie], color: this.props.colors[0] });
				}
				else if (serie.indexOf(`(${this.props.selectCountry2})`) > -1)
				{
					series.push({ name: serie, pointPlacement: 'on', data: auxSeries[serie], color: this.props.colors[1] });
				}
				else if (serie.indexOf(`(${this.props.selectCountry3})`) > -1)
				{
					series.push({ name: serie, pointPlacement: 'on', data: auxSeries[serie], color: this.props.colors[2] });
				}
			}
			
			this.setState({ chartConfig: {...this.state.chartConfig, xAxis: {...this.state.chartConfig.xAxis, categories}, series }});
		})

		this.setState({ chartConfig: {...this.state.chartConfig,  
			credits: {...this.state.chartConfig.credits, position: { x: chart.type == 'ewcs' ? -270 : -130 } } } });
	}

	updateDimension = () => {
		const width = window.innerWidth;
		const height = window.innerHeight;
		const title = this.props.fullCountryReport == true ? '' : this.props.reportTitle != undefined ? "<h2 class='title--card'>"+this.props.reportTitle+"</h2>" : 
			"<h2 class='title--card'>"+this.props.literals[`L${this.props.chartType[0].title}`]+"</h2>";
		const tabTitle = "<h2 class='title--card'>"+this.props.literals[`L${this.props.tabIndicator}`]+"</h2>"

		if (width < 767) {
			if (isFullscreen()) {
				this.setState({
					chartConfig: {
						...this.state.chartConfig,
						// chart: {...this.state.chartConfig.chart, width: width},
						chart: {...this.state.chartConfig.chart, height: height}
					}
				});
			} else {
				if (width < 570){
					if(width < 376){
						this.setState({
							chartConfig: {
								...this.state.chartConfig,
								chart: {...this.state.chartConfig.chart, height: 350},
								title: {
									...this.state.chartConfig.title,
									text: tabTitle,
									margin: 40
								}
							}
						})
					} else {
						this.setState({
							chartConfig: {
								...this.state.chartConfig,
								chart: {...this.state.chartConfig.chart, height: 400},
								title: {
									...this.state.chartConfig.title,
									text: tabTitle,
									margin: 50
								}
							}
						})
					}
				}
				else {
					this.setState({
						chartConfig: {
							...this.state.chartConfig,
							chart: {...this.state.chartConfig.chart, height: 450},
							title: {
								...this.state.chartConfig.title,
								text: tabTitle,
								margin: 50
							}
						}
					})
				}
			}
		} else {
			if (isFullscreen()) {
				this.setState({
					chartConfig: {
						...this.state.chartConfig,
						chart: {...this.state.chartConfig.chart, height: height}
					}
				});
			} else {
				this.setState({
					chartConfig: {
						...this.state.chartConfig,
						chart: {
							...this.state.chartConfig.chart, 
							height: this.props.fullCountryReport ? 500 : 600, 
						},
						title: {
							...this.state.chartConfig.title,
							text: title,
							margin: 40
						},
						// xAxis:{
						// 	...this.state.chartConfig.xAxis,
						// 	labels: {
						// 		distance:40
						// 	}
						// }
					}
				})
			}
		}
	}

	getCredits = (chart, dataset) => {
        getDatasourceAndDates(chart, dataset).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }

	componentDidMount(){
		this.getLoadData(this.props.chartType);

        this.setState({ typeCharts: this.props.chartType.map((chart) => chart.type) });

        if (this.props.callbackSelectedSurvey)
		{
			if (this.props.chartType[0].type == 'ewcs' && this.props.chartType.length > 1) {
				this.props.callbackSelectedSurvey(this.props.chartType[1].type)
			} else {
				this.props.callbackSelectedSurvey(this.props.chartType[0].type)
			}
		}		
        this.updateDimension();
        window.addEventListener('resize', this.updateDimension);
	}

	componentDidUpdate(prevProps,prevState){
		if (prevProps.chartType != this.props.chartType)
		{
			this.setState({ typeCharts: this.props.chartType.map((chart) => chart.type), selectedDataset: undefined, });

			this.getLoadData(this.props.chartType);
            this.updateDimension();
		}		

		if(prevProps.selectCountry1 != this.props.selectCountry1 || prevProps.selectCountry2 != this.props.selectCountry2 ||
			prevProps.selectCountry3 != this.props.selectCountry3 || prevProps.datasetSource != this.props.datasetSource ||
			prevProps.datasetID != this.props.datasetID){
            this.getLoadData(this.props.chartType);
        }

        if (prevProps.type != this.props.type) {
            this.setState({ chartConfig: {...this.state.chartConfig, chart: {...this.state.chartConfig.chart, type: this.props.type} }})
        }

		if(this.state.selectedChart == undefined){
			const chart = this.props.chartType.find((chart) => chart.type == this.props.datasetSource);
        	this.setState({ selectedTypeChart: chart.type, selectedChart: chart });
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimension);
	}

	render()
	{
		return (
			<React.Fragment>
				<div>
					<HighchartsReact
						highcharts={ Highcharts }
						options={ this.state.chartConfig }
					/>
				</div>
			</React.Fragment>
		)
	}
}

export default SpiderChart;